import React, { useState } from 'react'
import { Box, Typography, Chip } from '@mui/material'
import styles from '../CallAvailabilityView.module.scss'

const ALL_DAYS = [
  { key: 'sun', label: 'Sunday', short: 'S' },
  { key: 'mon', label: 'Monday', short: 'M' },
  { key: 'tue', label: 'Tuesday', short: 'T' },
  { key: 'wed', label: 'Wednesday', short: 'W' },
  { key: 'thu', label: 'Thursday', short: 'T' },
  { key: 'fri', label: 'Friday', short: 'F' },
  { key: 'sat', label: 'Saturday', short: 'S' }
]

const CompactInteractiveDaySelector = ({ selectedDays = [], onChange }) => {
  const [hoveredDay, setHoveredDay] = useState(null)

  const handleDayClick = (dayKey) => {
    if (selectedDays.includes(dayKey)) {
      onChange(selectedDays.filter((day) => day !== dayKey))
    } else {
      onChange([...selectedDays, dayKey])
    }
  }

  const selectWeekdays = () => {
    onChange(['mon', 'tue', 'wed', 'thu', 'fri'])
  }

  const selectAll = () => {
    onChange(ALL_DAYS.map((d) => d.key))
  }

  const clearAll = () => {
    onChange([])
  }

  return (
    <Box className={styles.compactDaySelector}>
      <Box className={styles.compactHeader}>
        <Typography variant='h6' className={styles.compactTitle}>
          Working Days
        </Typography>
        <Box className={styles.quickActions}>
          <button className={styles.quickButton} onClick={selectWeekdays} title='Monday to Friday'>
            Mon-Fri
          </button>
          <button className={styles.quickButton} onClick={selectAll} title='Select all days'>
            All
          </button>
          <button
            className={`${styles.quickButton} ${styles.clearButton}`}
            onClick={clearAll}
            title='Clear selection'
          >
            Clear
          </button>
        </Box>
      </Box>

      <Box className={styles.compactDaysGrid}>
        {ALL_DAYS.map((day) => {
          const isSelected = selectedDays.includes(day.key)
          const isHovered = hoveredDay === day.key

          return (
            <Box
              key={day.key}
              role='button'
              tabIndex={0}
              aria-pressed={isSelected}
              aria-label={isSelected ? `Deselect ${day.label}` : `Select ${day.label}`}
              className={`${styles.compactDayBubble} ${isSelected ? styles.selected : ''}`}
              onClick={() => handleDayClick(day.key)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault()
                  handleDayClick(day.key)
                }
              }}
              onMouseEnter={() => setHoveredDay(day.key)}
              onMouseLeave={() => setHoveredDay(null)}
            >
              <Typography variant='body2' className={styles.dayShort}>
                {day.short}
              </Typography>
              {isHovered && (
                <Typography variant='caption' className={styles.dayTooltip}>
                  {day.label}
                </Typography>
              )}
            </Box>
          )
        })}
      </Box>

      {selectedDays.length > 0 && (
        <Box className={styles.selectedSummary}>
          <Typography variant='caption' className={styles.summaryLabel}>
            Selected: {selectedDays.length} day{selectedDays.length !== 1 ? 's' : ''}
          </Typography>
          <Box className={styles.selectedChips}>
            {selectedDays.map((dayKey) => {
              const day = ALL_DAYS.find((d) => d.key === dayKey)
              return (
                <Chip
                  key={dayKey}
                  label={day?.label}
                  size='small'
                  onDelete={() => handleDayClick(dayKey)}
                  className={styles.compactChip}
                />
              )
            })}
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default CompactInteractiveDaySelector
